import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Container, Typography, Button, Box, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, Select, MenuItem
} from "@mui/material";

const UserDashboard = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedFirm, setSelectedFirm] = useState("Datachef");
  const navigate = useNavigate();
  const location = useLocation();
  const user = location.state?.user;
  const FIRMS = ["Datachef", "Techsahyogi"];

  useEffect(() => {
    if (!user) {
      navigate("/");
      return;
    }
    fetchJobs();
    // eslint-disable-next-line
  }, []);

  const fetchJobs = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/jobs`);
      console.log("Fetching jobs from:", `${process.env.REACT_APP_API_URL}/api/jobs`);
      setJobs(res.data);
    } catch (err) {
      alert("Failed to fetch jobs");
    }
    setLoading(false);
  };

  const handleCreateJob = () => {
    navigate("/user/new", { state: { user, firm: selectedFirm } });
  };

  const visibleJobs = jobs.filter(job => (job.firm || "Datachef") === selectedFirm);

  const handleLogout = () => {
    navigate("/");
  };

  return (
    <Container>
      <Box sx={{ display: "flex", justifyContent: "space-between", mt: 4 }}>
        <Typography variant="h4">User Dashboard</Typography>
        <Button variant="contained" color="secondary" onClick={handleLogout}>
          Logout
        </Button>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: 2, mb: 2 }}>
        <Select
          value={selectedFirm}
          onChange={e => setSelectedFirm(e.target.value)}
          size="small"
        >
          {FIRMS.map(f => (
            <MenuItem key={f} value={f}>{f}</MenuItem>
          ))}
        </Select>
        <Button
          variant="contained"
          color="primary"
          onClick={handleCreateJob}
        >
          Create New Job
        </Button>
      </Box>
      {loading ? (
        <Typography>Loading...</Typography>
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Job Received Date</TableCell>
                <TableCell>Job ID</TableCell>
                <TableCell>Firm</TableCell>
                <TableCell>Client Name</TableCell>
                <TableCell>Job Description</TableCell>
                <TableCell>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {visibleJobs.map((job) => (
                <TableRow key={job.id}>
                  <TableCell>{job.job_received_date?.slice(0, 10)}</TableCell>
                  <TableCell>{job.job_id}</TableCell>
                  <TableCell>{job.firm || "Datachef"}</TableCell>
                  <TableCell>{job.client_name}</TableCell>
                  <TableCell>{job.job_description}</TableCell>
                  <TableCell>{job.status}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Container>
  );
};

export default UserDashboard;
